import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../app/store';
import { Task } from 'types/data/task.t';

// Define a type for the slice state
interface TasksState {
  value: Task[];
}

// Define the initial state using that type
const initialState: TasksState = {
  value: []
};

export const tasksSlice = createSlice({
  name: 'tasks',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    addTask: (state, action: PayloadAction<Task>) => {
      state.value = [...state.value, action.payload];
    },
    removeTask: (state, action: PayloadAction<number>) => {
      state.value = state.value.filter(p => p.id !== action.payload);
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    updateTask: (state, action: PayloadAction<Task>) => {
      state.value = state.value.map(p => (p.id === action.payload.id ? action.payload : p));
    }
  }
});

export const { addTask, removeTask, updateTask } = tasksSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectTasks = (state: RootState) => state.tasks.value;

export default tasksSlice.reducer;
